var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('ofs-badge',{attrs:{"status":_vm.status,"text":_vm.getBadgeStatusText(_vm.status)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }